(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFieldDefinitionVersionsController', EventFieldDefinitionVersionsController);

    EventFieldDefinitionVersionsController.$inject = ['$uibModalInstance', 'entity', 'EventFieldDefinition', 'AlertService'];

    function EventFieldDefinitionVersionsController($uibModalInstance, entity, EventFieldDefinition, AlertService) {
        var vm = this;

        vm.fieldDefinition = entity;
        vm.versions = [];
        vm.clear = clear;

        EventFieldDefinition.versions({id: entity.id}, function(result) {
            vm.versions = result || [];
        }, function(error) {
            AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement des versions.');
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
